import styled from 'styled-components';

interface  GameDetailsContainerProps {
    squareGameIcon?: number
}

export const GameDetailsContainerDefaultBox = styled.div<GameDetailsContainerProps>`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-content: center;
    overflow: hidden;
    top: ${props => props.squareGameIcon? '10px' : '0'};
    min-height: 5rem;
    padding: 0 1rem 1rem;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        min-height: 4rem;
        padding: 0 0.4rem 1rem;
        justify-content: space-between;
        top: ${props => props.squareGameIcon? '5px' : '0'};
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        min-height: 3.5rem;
        padding-bottom: 0;
    }
    /** Glow Line Boottom **/
    &:after {
      content: "";
      position: absolute;
      background-image: url("${props => props.theme.images.horizontalLineGlowPC.toString()}");
      background-repeat: no-repeat;
      background-position: bottom center;
      background-size: contain;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 40px;
      margin: 0 auto;
      @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        background-image: url("${props => props.theme.images.horizontalLineGlowMobile.toString()}");
      }
    }
`;
